import React from 'react';
import ReactSVG from 'react-svg';
import * as lib from '~/dependencies';
import { SearchIcon } from '~/assets/svgIcons';
import { BoxBtn } from './styles';

export default function BtnSearch({ callback, value, ...rest }) {
  return (
    <BoxBtn onClick={() => callback(!value)} {...rest}>
      <ReactSVG src={SearchIcon} className="icon" />
    </BoxBtn>
  );
}

BtnSearch.defaultProps = {
  value: false,
  callback: () => {},
};

BtnSearch.propTypes = {
  value: lib.PropTypes.bool,
  callback: lib.PropTypes.func,
};
